import LendersLogo from "../../../sections/lead-gen/acn/lender-logos"

const SectionLenderLogo = ({ section }: any) => {
  const finalLang = "en_US"
  return <LendersLogo lang={finalLang} />
}

export default SectionLenderLogo
